import HcOIGSAMCheck from './HcOIGSAMCheck';

export default HcOIGSAMCheck;